import React from "react";
import styles from "./GalleryNavigation.module.scss";

const GalleryNavigation = () => {
  const scrollToSection = (selector) => {
    const element = document.querySelector(selector);
    if (!element) return;
    const y = element.getBoundingClientRect().top + window.scrollY;
    const headerHeight = document.querySelector("header")?.offsetHeight || 100;
    window.scroll({
      top: y - headerHeight,
      behavior: "smooth",
    });
  };

  const handleMenuItemClick = (item) => {
    const sectionMap = {
      about: ".aboutRef",
      artworks: ".artworksRef",
      artists: ".artistsRef",
      events: ".eventsRef",
      media: ".mediaRef",
    };

    const selector = sectionMap[item];
    if (selector) {
      scrollToSection(selector);
    }
  };
  return (
    <div className={styles.galleryNavigationContainer}>
      <div className="container">
        <ul>
          <li onClick={() => handleMenuItemClick("about")}>About Gallery</li>
          <li onClick={() => handleMenuItemClick("artworks")}>Artworks</li>
          <li onClick={() => handleMenuItemClick("artists")}>Artists</li>
          <li onClick={() => handleMenuItemClick("events")}>
            Exhibitions and Events
          </li>
          <li onClick={() => handleMenuItemClick("media")}>Media</li>
          <li className={styles.disabled}>Curators</li>
        </ul>
      </div>
    </div>
  );
};

export default GalleryNavigation;
